module.exports = __webpack_public_path__ + "img/dot-colors.f1e9fde3.svg";